import React from 'react';
import { CardSize } from 'components/CardSizeSelector/CardSizeSelector';
import OfferGridTile, { OfferGridTileProps } from './OfferGridTile';

export interface SourcePanelGridProps {
  size: CardSize;
  tiles: (OfferGridTileProps & { key: string | number })[];
  /** Server filtered total (N); rendered tiles are min(loaded, N). */
  totalCount: number;
  hasMore: boolean;
  isFetching: boolean;
  onLoadMore: () => void;
  phone?: boolean;
}

/**
 * The focus-mode body: an auto-fill tile grid (Decision 5) with Load More
 * accumulation (ruling 3). The remaining count on the button is
 * totalCount minus the tiles on screen, and the button disappears exactly
 * when they are equal.
 */
export const SourcePanelGrid: React.FC<SourcePanelGridProps> = ({
  size,
  tiles,
  totalCount,
  hasMore,
  isFetching,
  onLoadMore,
  phone = false,
}) => {
  const remaining = Math.max(0, totalCount - tiles.length);
  return (
    <div
      className={`offer-grid offer-grid--${size.toLowerCase()}`}
      data-testid="offer-grid"
      data-tile-count={tiles.length}
    >
      {tiles.map(({ key, ...tile }) => (
        <OfferGridTile key={key} {...tile} phone={phone} />
      ))}
      {hasMore && remaining > 0 && (
        <button
          type="button"
          className="offer-grid-load-more"
          onClick={onLoadMore}
          disabled={isFetching}
          data-testid="offer-grid-load-more"
        >
          {isFetching ? 'Loading…' : `Load more (${remaining.toLocaleString()} more)`}
        </button>
      )}
    </div>
  );
};

export default SourcePanelGrid;
